const urlName = '/company/v1/userCompanyX'

export default API => ({
  /**
   * 企业是否注册/审核是否通过
   */
  queryUserCompany () {
    return API({ url: `${urlName}/queryUserCompanyId` });
  }
})